// @flow
import * as React from 'react';
import DisconnectPortForm from 'esm-web-pro/containers/pages/network/objects/point12/poplayer12/DisconnectPortForm';


type Props = {
    port: Object,
    opticalPorts: Object[],
    onClose: Function,
    onSave: Function,
};

const DisconnectPortFromPortForm = (props: Props) => {
    const {
        port, opticalPorts, ...rest
    } = props;

    const maxRange = React.useCallback(() => {
        let maxOpticalPort = port.sequence;
        let maxPointPort = port.port.sequence;

        opticalPorts.forEach((opticalPort) => {
            if (opticalPort.sequence - maxOpticalPort === 1 && opticalPort.port
                && opticalPort.port.container.identity === port.port.container.identity) {
                maxOpticalPort = opticalPort.sequence;

                if (opticalPort.port.sequence - maxPointPort === 1) {
                    maxPointPort = opticalPort.port.sequence;
                }
            }
        });
        return Math.min(maxOpticalPort - port.sequence + 1, maxPointPort - port.port.sequence + 1);
    }, [opticalPorts, port]);

    return (
        <DisconnectPortForm
            port={port}
            object={{ port: port.port.id }}
            calculateMaxRange={maxRange}
            {...rest}
        />
    );
};

export default DisconnectPortFromPortForm;
